import React from 'react';
import { useNavigate } from 'react-router-dom';

const PoliticaPrivacidade = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center text-purple-600 hover:text-purple-700 mb-8"
        >
          <i className="fas fa-arrow-left mr-2"></i>
          Voltar
        </button>

        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Política de Privacidade</h1>
          <p className="text-gray-600 mb-4">Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>

          <div className="prose max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Coleta de Dados</h2>
              <p className="text-gray-700 mb-4">
                Coletamos apenas informações necessárias para a prestação dos serviços de transformação de site em aplicativo.
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Dados de contato para comunicação</li>
                <li>Informações do site para conversão</li>
                <li>Credenciais para publicação nas lojas</li>
                <li>Dados de uso para melhorias no serviço</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Uso das Informações</h2>
              <p className="text-gray-700 mb-4">
                Utilizamos os dados coletados exclusivamente para:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Desenvolvimento e conversão do aplicativo</li>
                <li>Comunicação sobre o andamento do projeto</li>
                <li>Suporte técnico e manutenção</li>
                <li>Melhorias nos nossos serviços</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Compartilhamento de Dados</h2>
              <p className="text-gray-700 mb-4">
                Não compartilhamos dados pessoais com terceiros, exceto quando necessário para:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Publicação nas lojas de aplicativos</li>
                <li>Integrações técnicas essenciais</li>
                <li>Obrigações legais</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Segurança</h2>
              <p className="text-gray-700 mb-4">
                Implementamos medidas de segurança para proteger seus dados contra acesso não autorizado.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Direitos do Usuário</h2>
              <p className="text-gray-700 mb-4">
                Você tem direito a acessar, corrigir e solicitar a exclusão de seus dados pessoais.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Contato</h2>
              <p className="text-gray-700">
                Para questões sobre privacidade, entre em contato através do nosso WhatsApp.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoliticaPrivacidade;